var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#242633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1034 11.6033C18.1836 11.3385 18.1116 11.0511 17.9159 10.8554C17.7203 10.6598 17.4328 10.5878 17.1681 10.668C13.1651 11.8813 10.25 15.5993 10.25 20.0002C10.25 25.3849 14.6152 29.7501 20 29.7501C24.4009 29.7501 28.1189 26.835 29.3321 22.8321C29.4124 22.5673 29.3404 22.2798 29.1447 22.0842C28.9491 21.8886 28.6616 21.8165 28.3968 21.8968C27.6392 22.1264 26.8347 22.2501 26 22.2501C21.4437 22.2501 17.75 18.5565 17.75 14.0001C17.75 13.1654 17.8737 12.3609 18.1034 11.6033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBtn);
export default __webpack_public_path__ + "static/media/darkBtn.2e1d71a7f7fcf60b42a9b37a1e454798.svg";
export { ForwardRef as ReactComponent };